import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./HowItWorks.css";

const steps = [
  {
    icon: "fa-list",
    title: "Choose your plan",
    text: "Pick a dedicated instance, cloud processing, or DevOp deployment plan that fits your needs.",
  },
  {
    icon: "fa-rocket",
    title: "We deploy",
    text: "Our team sets up your environment. You may be asked for access details—we aim to deploy within 1–3 days.",
  },
  {
    icon: "fa-check-circle",
    title: "You're live",
    text: "Access your instance or cloud and start working. Support is available whenever you need it.",
  },
];

const HowItWorks = () => (
  <section className="hn-how">
    <Container>
      <h2 className="hn-how-title">How it works</h2>
      <p className="hn-how-subtitle text-muted">Get from signup to production in three simple steps.</p>
      <Row className="g-4">
        {steps.map((step, i) => (
          <Col key={i} md="4">
            <div className="hn-how-card">
              <div className="hn-how-num">{i + 1}</div>
              <div className="hn-how-icon-wrap">
                <i className={`fas ${step.icon}`} aria-hidden="true" />
              </div>
              <h3 className="hn-how-step-title">{step.title}</h3>
              <p className="hn-how-step-text">{step.text}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default HowItWorks;
